// Sprint 945W — Instrument MUST be the first import so Sentry is up
// before React mounts (catches errors during the initial render).
import "./instrument";
// Sprint 946G — Cross-origin fetch rewrite must run BEFORE any React
// module reads process.env.REACT_APP_BACKEND_URL so all subsequent
// fetch/XHR calls go to the same origin when the env value is baked
// to a different host than the page is served from.
import "./lib/fetchRewrite";
// Sprint 1095 Phase 20 (carried over from Phase 12 perf pass) — service
// worker for static-asset caching. Production-only · idempotent · skips /api
// entirely so auth + live data are never cached at the SW layer.
import { registerServiceWorker } from "./lib/registerSW";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div
          data-testid="sentry-error-boundary-fallback"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#060608",
            color: "#d4d4d4",
            fontFamily: "-apple-system, Segoe UI, Roboto, sans-serif",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <h1 style={{ color: "#fff", fontSize: 28, margin: "0 0 12px" }}>
            Something went wrong.
          </h1>
          <p style={{ color: "#9ca3af", margin: "0 0 24px", maxWidth: 480 }}>
            We&apos;ve logged the error and our team has been notified. You can
            try reloading the page or returning to the home screen.
          </p>
          <div style={{ display: "flex", gap: 12 }}>
            <button
              onClick={resetError}
              data-testid="sentry-fallback-retry"
              style={{
                background: "#3b82f6",
                color: "#fff",
                fontWeight: 700,
                border: "none",
                padding: "10px 20px",
                borderRadius: 8,
                cursor: "pointer",
              }}
            >
              Try again
            </button>
            <a
              href="/"
              data-testid="sentry-fallback-home"
              style={{
                background: "transparent",
                color: "#d4d4d4",
                border: "1px solid #3a3a40",
                padding: "10px 20px",
                borderRadius: 8,
                textDecoration: "none",
                fontWeight: 600,
              }}
            >
              Home
            </a>
          </div>
          {error?.message && (
            <pre
              style={{
                marginTop: 32,
                fontSize: 11,
                color: "#6b7280",
                maxWidth: 600,
                whiteSpace: "pre-wrap",
              }}
            >
              {String(error.message).slice(0, 200)}
            </pre>
          )}
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// Register the static-asset service worker (production · HTTPS · post-load).
registerServiceWorker();
